import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { Observable } from "rxjs/Observable";
import { PersonalNestApi } from "../../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../../providers/global-service/global-service";
import { CompanyfacilityApi } from "../../../../shared/nestjs/gd-integrated/services/companyfacility.api";
import { ResponseListFacilityNameDto } from "../../../../shared/nestjs/gd-integrated/dto/companyfacility.dto";

@Injectable()
export class ProfileCompanyfacilityBloc {
  subscriptions: Array<Subscription> = [];

  constructor(
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    private companyfacilityApi: CompanyfacilityApi,
    public personalApi: PersonalNestApi,
    public globalService: GlobalServiceProvider,
  ) { }

  listing(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.companyfacilityApi.listing(payload)
          .subscribe((result) => {
            resolve(result.data)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          console.log('resultData', resultData)
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  getFacilityName(): Promise<ResponseListFacilityNameDto> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.companyfacilityApi.getListFacility()
          .subscribe((result) => {
            resolve(result.data)
          }, error => {
            reject(error);
          })
      )
    })
  }

  add(payload): Observable<any> {
    return this.companyfacilityApi.add(payload);
  }

  save(payload): Observable<any> {
    return this.companyfacilityApi.save(payload);
  }

  delete2(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.companyfacilityApi.delete(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  delete(payload): Observable<any> {
    console.log('>>- Delete', payload)
    return this.companyfacilityApi.delete(payload);
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-companyfacility/profile-companyfacility.bloc.ts